export interface TraceHeaderEnv {
    REACT_APP_WSE_API_URL?: string
    REACT_APP_BS_API_URL?: string
    REACT_APP_BOOKING_URL?: string
    REACT_APP_IDAM_URL?: string
}

const TRACE_HEADER_ENV_KEYS: Array<keyof TraceHeaderEnv> = [
    'REACT_APP_WSE_API_URL',
    'REACT_APP_BS_API_URL',
    'REACT_APP_BOOKING_URL',
    'REACT_APP_IDAM_URL'
]

const getTraceHeaderEnvFromProcess = (): TraceHeaderEnv => ({
    REACT_APP_WSE_API_URL: process.env.REACT_APP_WSE_API_URL,
    REACT_APP_BS_API_URL: process.env.REACT_APP_BS_API_URL,
    REACT_APP_BOOKING_URL: process.env.REACT_APP_BOOKING_URL,
    REACT_APP_IDAM_URL: process.env.REACT_APP_IDAM_URL
})

export const getTraceHeaderCorsUrls = (env: TraceHeaderEnv = getTraceHeaderEnvFromProcess()): Array<string | RegExp> => {
    const urls: Array<string | RegExp> = []

    for (const key of TRACE_HEADER_ENV_KEYS) {
        const value = env[key]
        if (value) {
            urls.push(value)
        }
    }

    return urls
}
